import ActivitesLayout from '@/layout/ActivitesLayout/index.vue'

const activitesMap = [
  {
    path: '/activites',
    name: 'Activites',
    component: ActivitesLayout,
    redirect: '/activites/activites-home',
    children: [
      {
        path: '/activites/activites-home',
        name: 'ActivitesHome',
        component: () => import('@/views/activites/activitiesHome'),
        meta: {
          name: '活动'
        },
      },
    ]
  }
]

export default activitesMap